import React, { useState } from "react";
import { Button, message, Modal, Space, Typography, Upload } from "antd";
import type { UploadProps, RcFile, UploadFile } from 'antd/es/upload/interface';
import { CloudUploadOutlined } from "@ant-design/icons";
import { GetDataSettlementSubject, importCancelExcel, importClosingExcel } from "../../../../../services/dct/DctService";

import clsName from './index.module.scss'

const { Text } = Typography;

// 导入失败
interface ErrorItem {
  erroy: string
}

interface ImportModalProps {
  type: number
  onClose?: () => void
  onReload?: () => void
}
const ImportModal: React.FC<ImportModalProps> = ({ type, onClose, onReload }) => {

  const [errors, setErrors] = useState<ErrorItem[]>([]);
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const props: UploadProps = {
    name: 'file',
    accept: ".xlsx,.xls",
    maxCount: 1,
    fileList,
    headers: {
      authorization: 'authorization-text',
    },
    beforeUpload: file => {
      const isLt = file.size > 30 * 1024 * 1024;
      const allowedTypes = [".xlsx", ".xls"];
      const fileType = file.name.slice(file.name.lastIndexOf('.'))

      if(isLt){
        message.error(`文件大小不能超过30MB`);
      }else if(!allowedTypes.includes(fileType)){
        message.error(`请上传xlsx或者xls类型文件`);
      }else{
        setFileList([file])
      }
      return false
    },

    onRemove: file => {
      const files = [...fileList]
      files.splice(files.indexOf(file), 1)
      setFileList(files)
    },
  };

    // 结算标记弹窗操作
    const handleConfirm = async ()=>{
      if(!fileList.length){
        message.error("请上传完成标记文件")
        return
      }

      const uploadFormData = new FormData();

      fileList.forEach(file => {
        uploadFormData.append('file', file as RcFile);
      });

      const { code, data } = await (type === 1 ? importClosingExcel : importCancelExcel)(uploadFormData)

      if(code === 0) {
        if(data.length === 0){
          message.success("导入成功！")
          setFileList([])
          setErrors([])
          onClose?.()
          onReload?.()
        }else{
          setErrors(data)
        }
      }
    }

    const handleCancel = ()=>{
      onClose?.()
      setErrors([])
      setFileList([])
    }

    const handleDownLoadTemplate = async ()=>{
      const res = await GetDataSettlementSubject()

      // 创建一个Blob URL
      const url = window.URL.createObjectURL(new Blob([res]));

      // 创建一个<a>标签并设置其href属性为Blob URL
      const a = document.createElement('a');
      a.href = url;
      a.download = '废弃模板.xlsx';

      // 触发下载
      document.body.appendChild(a);
      a.click();

      // 清理（从DOM中移除并撤销Blob URL）
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);

    }

    return (
      <Modal
        title="导入数据"
        open
        onOk={handleConfirm}
        onCancel={handleCancel}
        okText="导入"
        cancelText="取消"
      >
        {
          type === 2 && (
            <Space size={0}>
              <Text>请先下载模板信息，更新后上传，</Text>
              <Button type="link" size="small" onClick={handleDownLoadTemplate}>点击下载模板</Button>
            </Space>
          )
        }
        <Upload.Dragger {...props}>
          <Space direction="vertical" align="center" size={0}>
            <div className={clsName.icon}>
              <CloudUploadOutlined style={{ fontSize: '32px', color: '#1890ff' }}/>
            </div>
            <Text>将文件拖到此处，或点击上传</Text>
            <Text type="secondary">只能上传xlsx文件，且不超过30MB</Text>
          </Space>
        </Upload.Dragger>
        {
          errors.length > 0 && (
            <div className={clsName.contents}>
                <div className={clsName.tips}>请仔细查看下列数据，修改后可重新上传审核</div>
                <div className={clsName.errors}>
                    <div className={clsName.error}>一共有<span>&nbsp;{errors.length}&nbsp;</span>条错误:</div>
                    {
                      errors.map(({ erroy }, i) => (
                        <div className={clsName.error} key={i}>{i + 1}. {erroy}</div>
                      ))
                    }
                </div>
            </div>
          )
        }
      </Modal>
    );
};

export default ImportModal;
